import Box from '@mui/material/Box'
import Skeleton from '@mui/material/Skeleton'
import Stack from '@mui/material/Stack'
import { TemplateTileSkeleton } from './TemplateTileSkeleton'
import { TEMPLATE_SKELETON_LINE } from './templateSkeletonCommon'

function CategoryBlockSkeleton({ tileCount }: Readonly<{ tileCount: number }>) {
  return (
    <Box sx={{ mb: 3 }}>
      <Skeleton
        variant="rounded"
        width={220}
        height={31}
        sx={{ ...TEMPLATE_SKELETON_LINE, mb: 3 }}
        aria-hidden
      />
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, minmax(0, 1fr))' },
          gap: '24px',
        }}
      >
        {Array.from({ length: tileCount }, (_, i) => (
          <TemplateTileSkeleton key={i} />
        ))}
      </Box>
    </Box>
  )
}

export function InstrumentTemplateLibrarySkeleton() {
  return (
    <Stack
      spacing={0}
      data-testid="instrument-template-library-skeleton"
      aria-busy
      aria-label="Loading templates"
    >
      <CategoryBlockSkeleton tileCount={2} />
      <CategoryBlockSkeleton tileCount={2} />
    </Stack>
  )
}
